export default {
    teachers:[],
    teachersMeta:'',
}
  